import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import FlashboxLanding from './flashbox-landing';
import FlashboxAuth from './flashbox-auth';
import FlashboxPortal from './flashbox-portal';
import FlashboxAdmin from './flashbox-admin';
import Terminos from './flashbox-terminos';
import Privacidad from './flashbox-privacidad';
import SubirFactura from './flashbox-subir-factura';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/"           element={<FlashboxLanding />} />
      <Route path="/login"      element={<FlashboxAuth />} />
      <Route path="/portal"     element={<FlashboxPortal />} />
      <Route path="/admin"      element={<FlashboxAdmin />} />
      <Route path="/subir-factura" element={<SubirFactura />} />
      <Route path="/terminos"   element={<Terminos />} />
      <Route path="/privacidad" element={<Privacidad />} />
      <Route path="*"           element={<Navigate to="/" />} />
    </Routes>
  </BrowserRouter>
);
